import React, { createContext, useContext, useState } from 'react';

const CopyMoveContext = createContext();

export const useCopyMove = () => {
  const context = useContext(CopyMoveContext);
  if (!context) {
    throw new Error('useCopyMove must be used within a CopyMoveProvider');
  }
  return context;
};

export const CopyMoveProvider = ({ children }) => {
  const [showCopyMoveDialog, setShowCopyMoveDialog] = useState(false);
  const [singleTask, setSingleTask] = useState(null);

  const openCopyMoveDialog = (taskData = null) => {
    setSingleTask(taskData);
    setShowCopyMoveDialog(true);
  };

  const closeCopyMoveDialog = () => {
    setShowCopyMoveDialog(false);
    setSingleTask(null);
  };

  return (
    <CopyMoveContext.Provider 
      value={{ 
        showCopyMoveDialog,
        singleTask,
        openCopyMoveDialog,
        closeCopyMoveDialog
      }}
    >
      {children}
    </CopyMoveContext.Provider>
  );
};